import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { PaymentError } from '../entities';
import { paymentFormFailed, paymentFormSucceed } from '../store/actions';
import { getRecurringData } from '../store/selectors';

export function useThreeDomainSecurePayment() {
  const dispatch = useDispatch();

  const paymentProcessingData = useSelector(getRecurringData);

  const doPaymentFormFailed = useCallback(
    (error: PaymentError) => {
      dispatch(paymentFormFailed(error));
    },
    [dispatch],
  );

  const doPaymentFormSucceed = useCallback(() => {
    dispatch(paymentFormSucceed());
  }, [dispatch]);

  return {
    paymentProcessingData,
    paymentFormFailed: doPaymentFormFailed,
    paymentFormSucceed: doPaymentFormSucceed,
  };
}
